import { atomWithStorage } from 'jotai/utils';
import { atom } from 'jotai/vanilla';

const builtinPluginPaths = /* @__PURE__ */ new Set([
  "/plugins/bookmark",
  "/plugins/copilot",
  "/plugins/hello-world",
  "/plugins/image-preview",
  "/plugins/vue-hello-world"
]);
const pluginCleanupMap = /* @__PURE__ */ new Map();
function addCleanup(pluginName, cleanup) {
  if (!pluginCleanupMap.has(pluginName)) {
    pluginCleanupMap.set(pluginName, []);
  }
  pluginCleanupMap.get(pluginName)?.push(cleanup);
}
function invokeCleanup(pluginName) {
  pluginCleanupMap.get(pluginName)?.forEach((cleanup) => cleanup());
  pluginCleanupMap.delete(pluginName);
}
const pluginPackageJson = atom([]);
const enabledPluginAtom = atomWithStorage("affine-enabled-plugin", [
  "@affine/bookmark-plugin",
  "@affine/image-preview-plugin"
]);
const pluginHeaderItemAtom = atom({});
const pluginSettingAtom = atom(
  {}
);
const pluginEditorAtom = atom({});
const pluginWindowAtom = atom({});

export { addCleanup, builtinPluginPaths, enabledPluginAtom, invokeCleanup, pluginEditorAtom, pluginHeaderItemAtom, pluginPackageJson, pluginSettingAtom, pluginWindowAtom };
